import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const ViewStudentProfile = () => {
  const routes = all_routes;

  // Mock data for testing
  const mockStudent = {
    id: 1,
    name: 'Emily Johnson',
    rollNo: 'STU001',
    class: 'Grade 10A',
    section: 'A',
    admissionDate: '2023-09-01',
    phone: '+1 234-567-8901',
    email: 'emily.johnson@student.edu',
    photo: 'assets/img/profiles/avatar-01.jpg',
    address: '123 Main St, City, State 12345',
    emergencyContact: 'Sarah Johnson - +1 234-567-8900'
  };

  const mockAcademics = {
    currentGPA: 3.8,
    attendance: 94,
    rank: 12,
    totalStudents: 45
  };

  const mockSubjects = [
    { id: 1, name: 'Mathematics', teacher: 'Ms. Smith', grade: 'A' },
    { id: 2, name: 'Physics', teacher: 'Dr. Brown', grade: 'B+' },
    { id: 3, name: 'English', teacher: 'Mr. Davis', grade: 'A-' },
    { id: 4, name: 'Chemistry', teacher: 'Ms. Wilson', grade: 'B' }
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Student Profile</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={routes.parentDashboard}>Parent Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Student Profile</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Student Info Card */}
          <div className="row">
            <div className="col-md-4">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-xl mx-auto mb-3">
                    <img src={mockStudent.photo} alt="Student" className="rounded-circle" />
                  </div>
                  <h4>{mockStudent.name}</h4>
                  <p className="text-muted">{mockStudent.class} - Roll No: {mockStudent.rollNo}</p>
                  
                  <div className="row text-center mt-4">
                    <div className="col-6">
                      <h5 className="text-primary">{mockAcademics.currentGPA}</h5>
                      <p className="text-muted mb-0">Current GPA</p>
                    </div>
                    <div className="col-6">
                      <h5 className="text-success">{mockAcademics.attendance}%</h5>
                      <p className="text-muted mb-0">Attendance</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Quick Actions</h5>
                </div>
                <div className="card-body">
                  <div className="d-grid gap-2">
                    <Link to={routes.studentGrades} className="btn btn-primary">
                      <i className="ti ti-trophy me-2"></i>View Grades
                    </Link>
                    <Link to={routes.studentAttendanceView} className="btn btn-success">
                      <i className="ti ti-calendar-check me-2"></i>Attendance Report
                    </Link>
                    <Link to={routes.paymentHistory} className="btn btn-warning">
                      <i className="ti ti-credit-card me-2"></i>Fee Status
                    </Link>
                    <Link to={routes.parentDocumentRequests} className="btn btn-info">
                      <i className="ti ti-file-text me-2"></i>Request Documents
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-8">
              {/* Personal Information */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Personal Information</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Full Name</label>
                        <p className="form-control-static">{mockStudent.name}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Roll Number</label>
                        <p className="form-control-static">{mockStudent.rollNo}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Class & Section</label>
                        <p className="form-control-static">{mockStudent.class} - Section {mockStudent.section}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Admission Date</label>
                        <p className="form-control-static">{mockStudent.admissionDate}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Phone</label>
                        <p className="form-control-static">{mockStudent.phone}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Email</label>
                        <p className="form-control-static">{mockStudent.email}</p>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label className="form-label">Address</label>
                        <p className="form-control-static">{mockStudent.address}</p>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label className="form-label">Emergency Contact</label>
                        <p className="form-control-static">{mockStudent.emergencyContact}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Academic Performance */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Academic Performance</h5>
                </div>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-md-3">
                      <div className="text-center">
                        <h4 className="text-primary">{mockAcademics.currentGPA}</h4>
                        <p className="text-muted mb-0">Current GPA</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <h4 className="text-success">{mockAcademics.attendance}%</h4>
                        <p className="text-muted mb-0">Attendance</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <h4 className="text-warning">{mockAcademics.rank}</h4>
                        <p className="text-muted mb-0">Class Rank</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <h4 className="text-info">{mockAcademics.totalStudents}</h4>
                        <p className="text-muted mb-0">Total Students</p>
                      </div>
                    </div>
                  </div>

                  {/* TODO Placeholders */}
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to student API</h6>
                    <ul className="mb-0">
                      <li>Fetch student profile data</li>
                      <li>Display academic history/transcripts</li>
                      <li>Show attendance patterns</li>
                      <li>Contact information updates</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Current Subjects */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Current Subjects</h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Subject</th>
                          <th>Teacher</th>
                          <th>Current Grade</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockSubjects.map(subject => (
                          <tr key={subject.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar avatar-sm bg-light me-2">
                                  <i className="ti ti-book"></i>
                                </div>
                                {subject.name}
                              </div>
                            </td>
                            <td>{subject.teacher}</td>
                            <td>
                              <span className={`badge ${
                                subject.grade.startsWith('A') ? 'badge-soft-success' :
                                subject.grade.startsWith('B') ? 'badge-soft-primary' :
                                'badge-soft-warning'
                              }`}>
                                {subject.grade}
                              </span>
                            </td>
                            <td>
                              <button className="btn btn-sm btn-outline-primary">
                                <i className="ti ti-eye"></i> Details
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewStudentProfile;
